import React, { useState, useEffect, Fragment } from 'react';


import PageNav from '../components/PageNav';

import Container from '@mui/material/Container';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';

import Card from '@mui/material/Card';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';

import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

import { general, urls } from '../config.js'

import FilterAltIcon from '@mui/icons-material/FilterAlt';


import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';

import PersonIcon from '@mui/icons-material/Person';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';



import moment from 'moment';

import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import SearchNavBar from '../components/SearchNavBar';




const persIcon = <PersonIcon fontSize="" />

let zerotoTwo = Array.from(Array(4).keys())

function Search() {
  window.scrollTo(0, 0)


  const useCustomSearchParams = () => {
    const [search, setSearch] = useSearchParams();
    const searchAsObject = Object.fromEntries(
      new URLSearchParams(search)
    );

    return [searchAsObject, setSearch];
  };

  const [ImageIsLoading, setImageIsLoading] = useState(true);


  function onLoad() {
    // delay for demo only
    setTimeout(() => setImageIsLoading(false), 1000);

    // setIsLoading(false)
  }

  //const [query, setQuery] = useState('');
  const navigate = useNavigate()

  const [videos, setVideos] = useState([]);
  const [notFound, setNotFound] = useState(false)
  const [pages, setPages] = useState([]);
  const [search] = useCustomSearchParams();
  const [active, setActive] = useState([]);

  const [pageChanged, setPageChanged] = useState(true);

  const [isLoading, setLoading] = useState(true)
  const [filtersActivated, setFiltersActivated] = useState(false)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.up('sm'))

  const query = search.q
  const page = search.p
  const username = search.u
  const startDate = search.s
  const endDate = search.e
  const language = search.l
  const ordering = search.o

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const bottomTrue = true;
  const bottomFalse = false;

  const [flter, setFilter] = useState("")


  function handleChange(evt) {
    const value = evt.target.value;
    navigate(replaceUrlParam(url, "o", value));
  }


  // declare the async data fetching function
  const fetchData = async () => {
    let string = `${urls.clipSearch}?query=${query}&page=${page}`
    if (username !== undefined || username === "") {
      string = string + `&username=${username}`
    }
    if (startDate !== undefined || startDate === "") {
      string = string + `&startdate=${startDate}`
    }
    if (endDate !== undefined || endDate === "") {
      string = string + `&enddate=${endDate}`
    }
    if (language !== undefined || language === "") {
      string = string + `&language=${language}`
    }
    if (ordering !== undefined || ordering === "") {
      string = string + `&ordering=${ordering}`
    }
    const data = await fetch(string);
    // convert the data to json
    const json = await data.json();


    // set state with the result

    setLoading(false)
    if (json.clips.length === 0) {
      setNotFound(true)
    }
    setVideos(json.clips);
    setPages(json.pages);
    setActive(json.page);
  };

  function replaceUrlParam(url, paramName, paramValue) {
    if (paramValue == null) {
      paramValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
      return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '&') + paramName + '=' + paramValue;
  }

  let url = window.location.search



  const fetchDataPageOne = async () => {
    let string = `${urls.clipSearch}?query=${query}`
    if (username !== undefined || username === "") {
      string = string + `&username=${username}`
    }
    if (startDate !== undefined || startDate === "") {
      string = string + `&startdate=${startDate}`
    }
    if (endDate !== undefined || endDate === "") {
      string = string + `&enddate=${endDate}`
    }
    if (language !== undefined || language === "") {
      console.log(language)
      string = string + `&language=${language}`
    }
    if (ordering !== undefined || ordering === "") {
      string = string + `&ordering=${ordering}`
    }
    const data = await fetch(string);
    // if (searchParams.get("username") !== undefined) {
    //  str =  str + `&username=${username}`
    // }
    // convert the data to json
    const json = await data.json();

    // set state with the result
    setLoading(false)
    if (json.clips.length === 0) {
      setNotFound(true)
    }
    setVideos(json.clips);
    setPages(json.pages);
    setActive(json.page);
  };

  useEffect(() => {
    setLoading(true)
    document.title = `Searching for ${query}`
    setFiltersActivated(false)
    // call the function
    page === undefined ?
      fetchDataPageOne() : fetchData()
      setPageChanged(false)
    // eslint-disable-next-line
  }, [query, page, username, startDate, endDate, language, ordering]);



  return (
    <Container maxWidth="lg">
      <div class="title">
        <h2>Search for {query}</h2>
      </div>


      {isLoading ?
        <>
          <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 1, sm: 10, md: 12 }} marginTop={2} marginBottom={2}>
            {zerotoTwo.map((person, i) => (

              <>
                <Grid xs={1} sm={4} md={3} key={i}>
                  <item>

                    <Skeleton variant="rectangular" height={140} />
                    <Box sx={{ pt: 0.5 }}>
                      <Skeleton />
                      <Skeleton width="60%" />
                    </Box>
                  </item>
                </Grid>

              </>

            ))}

          </Grid>

        </> :
        <>
          <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
            {(!notFound && !pageChanged) &&

              <item><PageNav pages={pages} active={active} disabled /></item>
            }

            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
              <InputLabel id="filter">Order by</InputLabel>
              <Select 
                labelId="ordering"
                name="ordering"
                value={ordering}
                label="Order by"
                onChange={handleChange}
              >
                <MenuItem value="ca-d">
                  <em>Created at - descending</em>
                </MenuItem>
                <MenuItem value="ca-a">Created at - ascending</MenuItem>
                <MenuItem value="at-d">Date added to {general.siteName} - descending</MenuItem>
                <MenuItem value="at-a">Date added to {general.siteName} - ascending</MenuItem>
              </Select>
            </FormControl>

            {(filtersActivated == false) ?
              <Button variant="contained" startIcon={<FilterAltIcon />} onClick={
                () => {
                  setFiltersActivated(true)
                }
              }>
                Search filters
              </Button>

              :

              <Button variant="outlined" startIcon={<FilterAltIcon />} onClick={
                () => {
                  setFiltersActivated(false)
                }
              }>
                Search filters
              </Button>


            }




          </Stack>

          {filtersActivated &&
            <SearchNavBar query={query} language={language} enddate={endDate} startdate={startDate} username={username} />}
          {notFound &&
            <Box id="nothingFound search">

              <h6>Nothing found :(</h6>
            </Box>

          }
          <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 1, sm: 10, md: 12 }} marginTop={2} marginBottom={2}>
            {videos.map((video, index) => {

              let tagString = String(`
              ${video.broadcaster_name}
              `)



              return (
                <Grid xs={1} sm={4} md={3} key={index}>
                  <item>
                    <Card sx={{ maxWidth: 500 }} onClick={() => window.open(`https://clips.twitch.tv/${video.id}`, '_blank')}>
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          image={video.thumbnail_url}
                        />
                        <CardContent>
                          <Typography gutterBottom variant="h5" component="div" id="videoTitle" style={{ fontSize: 17 }}>
                            {video.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {persIcon}
                            {tagString}
                            <br />
                            <AccessTimeFilledIcon fontSize="" />  {" "}
                            {moment(video.created_at).fromNow()}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </item>
                </Grid>
              )
            })}
          </Grid>
          {!notFound &&
            <item><PageNav pages={pages} active={active} disabled /></item>
          }
        </>
      }

    </Container>
  );
};



export default Search